import siteConfig from "site-config";
import { IRequestAction, progressEpic } from "epics/base-epic";
import { DELIVERY_WINDOWS } from "constants/action-types";
import { IDeliveryWindow } from "constants/delivery-windows";

export const fetchPredefinedEpic = progressEpic<IRequestAction, IDeliveryWindow[]>(
    DELIVERY_WINDOWS.PREDEFINED.FETCH,
    ({ payload }) => ({
        method: "GET",
        url: siteConfig.api + payload.url,
    }),
);

export const fetchReplenishmentEpic = progressEpic<IRequestAction, IDeliveryWindow[]>(
    DELIVERY_WINDOWS.REPLENISHMENT.FETCH,
    ({ payload }) => ({
        method: "GET",
        url: siteConfig.api + payload.url,
    }),
);
